import { internationalDestinationGuide } from 'config/track-config';

export const tooltipContent = {
  timeWindow: (
    <>
      <p>
        This 2-hour time window was calculated when the postie started their round. It won’t be updated during the day.
      </p>
      <p>
        If the postie is either held up or ahead of schedule, you’ll notice a message following the time window shown.
      </p>
    </>
  ),
  edd: (
    <>
      <p>
        This date or range takes into account any current disruptions on this parcel’s journey, but it may not allow for
        local public holidays.
      </p>
      <p>It’s a prediction based on our latest data for deliveries between similar locations.</p>
      <p>We’ll update it as the parcel progresses.</p>
    </>
  ),
  inlineEdd: (
    <>
      <p>These dates are a one-time calculation based on the delivery location you entered.</p>
      <p>
        They take into account any current disruptions on this parcel’s journey, but they won’t update automatically as
        the parcel progresses.
      </p>
      <p>To check for updates, you’ll need to re-calculate these dates each time you track this parcel.</p>
    </>
  ),
  international: (
    <>
      <p>
        We can’t calculate the expected arrival dates for this parcel, because it will be delivered outside of
        Australia.
      </p>
      <p>
        To see how long similar deliveries are taking, check our&nbsp;
        <a href={internationalDestinationGuide}>international destination guide</a>.
      </p>
    </>
  ),
  default: (
    <>
      <p>We calculate expected arrival dates the first time we scan a parcel’s label.</p>
      <ul>
        <p>Usually, this will happen when:</p>
        <li>it’s picked up from the sender</li>
        <li>it’s sent at a Post Office</li>
        <li>it arrives at a sorting facility</li>
      </ul>
    </>
  ),
};
